module.exports = __webpack_public_path__ + "static/img/5.b3d15de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/eng/5.png
// module id = DUgz
// module chunks = 0